import { configureStore } from '@reduxjs/toolkit';
import {
  authReducer,
  checkoutCurrencyReducer,
  checkoutReducer,
  geoDiscountReducer,
} from '../features';
import { rootListener } from './listener';

const rootStore = configureStore({
  reducer: {
    auth: authReducer,
    checkout: checkoutReducer,
    geoDiscount: geoDiscountReducer,
    checkoutCurrency: checkoutCurrencyReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(rootListener.middleware),
  devTools: process.env.NODE_ENV !== 'production',
});

export { rootStore };
